import React, { useState } from "react";
import "./TestSummary.css";

function TestSummary() {
  const [report, setReport] = useState("");
  const [summary, setSummary] = useState("");
  const [loading, setLoading] = useState(false);

  const generateSummary = async () => {
    if (!report.trim()) return;

    setLoading(true);
    setSummary("");

    try {
      const response = await fetch(
        "https://qa-ai-platform-backend.onrender.com/api/test-summary",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ report }),
        }
      );

      const data = await response.json();
      setSummary(data.summary || "No summary generated.");
    } catch (err) {
      console.error(err);
      setSummary("Failed to generate test summary.");
    }

    setLoading(false);
  };

  return (
    <div className="summary-container">
      <h1>📄 AI Test Summary</h1>

      <textarea
        placeholder="Paste test execution logs or results..."
        value={report}
        onChange={(e) => setReport(e.target.value)}
      />

      <button onClick={generateSummary} disabled={loading}>
        {loading ? "Generating..." : "Generate Summary"}
      </button>

      {summary && (
        <div className="summary-output">
          <pre>{summary}</pre>
        </div>
      )}
    </div>
  );
}

export default TestSummary;
